module.exports = __webpack_public_path__ + "media/images/testimonial-servicemaster-e648e215705551290675564e93997649.png";